import { prefixerC } from '.'

export const ROUTE_NIVEL_APROBACION_ANTICIPOS = prefixerC('permisos-niveles-aprobacion-anticipos')
export const ROUTE_ASIGNACION_TAREAS = prefixerC('asignacion-tareas')
export const ROUTE_FECHA_LIMITE_REGDOC = prefixerC('fecha-limite-regdoc')
export const ROUTE_CORREO_ALERTAS_PENDIENTE = prefixerC('correo_alertas_pendientes')
export const ROUTE_USUARIOS_NOTIFICACION = prefixerC('usuarios_notifiacion')
